// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"0f368f64","488":"2b38ea96","577":"3c38433c","700":"9201bea4","714":"a881ea1e","992":"353df5ff"}[chunkId] + ".chunk.js";
};